import { Callout } from "@octopusdeploy/design-system-components";
import { useState } from "react";
import * as React from "react";
import { repository } from "~/clientInstance";
import DeleteDialogLayout from "~/components/Dialog/DeleteDialogLayout";
import type { ParentEnvironmentModel } from "../ParentEnvironmentLayout/ParentEnvironmentPage";
interface DeleteParentEnvironmentDialogLayoutProps {
    environment: ParentEnvironmentModel;
    onDelete(): void;
}
export const DeleteParentEnvironmentDialogLayout: React.FC<DeleteParentEnvironmentDialogLayoutProps> = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const onLoad = async () => {
        setIsLoading(false);
    };
    const onDeleteClick = async () => {
        await repository.ParentEnvironments.delete({ Id: props.environment.Id, SpaceId: props.environment.SpaceId });
        props.onDelete();
        return true;
    };
    return (<DeleteDialogLayout title={"Are you sure you want to delete this environment?"} onDeleteClick={onDeleteClick} onLoad={onLoad} renderContent={() => (<React.Fragment>
                    {!isLoading && (<React.Fragment>
                            <p>Deleting this environment is permanent. There is no going back.</p>
                            <p>Do you wish to continue?</p>
                            <Callout title={"In-use environments must not be deleted"} type={"warning"}>{`Please check the 'environments' fields of your deployment, runbook & variables OCL files for references to '${props.environment.Slug}' before deleting this environment.`}</Callout>
                        </React.Fragment>)}
                </React.Fragment>)}/>);
};
DeleteParentEnvironmentDialogLayout.displayName = "DeleteParentEnvironmentDialogLayout"
